import HasBeenReset from './container';

export default HasBeenReset;



// WEBPACK FOOTER //
// ./src/views/Auth/HasBeenRest/index.js